import { Box, Typography } from '@mui/material';
import useRequestStore from '../../../store/request';
import RequestDevelopmentInfo from './RequestDevelopmentInfo';
import RequestProductInfo from './RequestProductInfo';
import RequestWebhostingInfo from './RequestWebhostingInfo';
import RequestConsultingInfo from './RequestConsultingInfo.jsx';

export default function RequestDetails({ next, back }) {
  const { type } = useRequestStore((state) => state.data);

  return (
    <>
      <Box sx={{ mb: '16px' }}>
        <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>
          Verraten Sie uns ein paar Details
        </Typography>
        <Typography sx={{ fontSize: '14px' }}>
          Um Ihre Anfrage von Anfang an optimal bearbeiten zu können, würden wir
          uns über ein paar Informationen freuen.
        </Typography>
      </Box>
      {type === 'development' && (
        <RequestDevelopmentInfo next={next} back={back} />
      )}
      {type === 'product' && <RequestProductInfo next={next} back={back} />}
      {type === 'webhosting' && (
        <RequestWebhostingInfo next={next} back={back} />
      )}
      {type === 'consulting' && (
        <RequestConsultingInfo next={next} back={back} />
      )}
    </>
  );
}
